import type { Components, Theme } from "@mui/material/styles";

export const MuiInputAdornment: Components<Theme>["MuiInputAdornment"] = {
  styleOverrides: {
    root: {
      margin: "unset",
    },
  },
};
